<template>
  <div class="menuFrame">
    <loading :active.sync="isLoading"></loading>

    <div id="track">
      <div class="d-flex justify-content-between">
        <div>
          <a href="/ExhibitorServiceTW/en">Exhibition List</a><span>/</span>
          <em name="Exhibition"></em> <span>/</span>
          <a href="javascript: history.back()">Products</a> <span>/</span>Edit
          Products
        </div>
        <div>
          <span class="bold">Account :</span>
          <span> {{ UserId }}</span>
        </div>
      </div>
    </div>
    <!-- track end -->
    <!-- article -->
    <article>
      <div class="contentBox">
        <div>
          <h1>Edit Products</h1>
          <p class="my-3">&nbsp;</p>
          <div>
            <div
              class="alert"
              v-if="ProductWarning == 'N/A'"
              name="ProductWarning"
            >
              <div>
                <i class="fas fa-exclamation-circle mr-1"></i>
                The product information you create must comply with the
                regulations of the relevant organization. If there is any
                dispute, the organizer reserves the right to decide the final
                product to be put on the shelf.
              </div>
              <div class="mt-1">
                <i class="fas fa-exclamation-circle mr-1"></i> After your edit
                on the information of picture and product, please click
                "Confirm" to proceed.
              </div>
            </div>
            <div
              class="alert"
              v-else-if="ProductWarning !== 'N/A'"
              name="ProductWarning"
            >
              <div>
                <i class="fas fa-exclamation-circle mr-1"></i>
                {{ ProductWarning }}
              </div>
              <div class="mt-1">
                <i class="fas fa-exclamation-circle mr-1"></i> After your edit
                on the information of picture and product, please click
                "Confirm" to proceed.
              </div>
            </div>
          </div>
          <p class="my-3">&nbsp;</p>

          <form
            id="form"
            enctype="multipart/form-data"
            @submit.prevent="updateProduct"
          >
            <!-- left -->

            <!-- PC版圖片顯示 -->

            <div class="proLeft PcDevice">
              <label class="inputFile">
                <div class="squareThumb pointer ImgHoverStyle">
                  <img :src="modelSrc" class="img-fluid" />
                </div>

                <p class="my-3">&nbsp;</p>
                <span name="showName" class="nowrap"></span>
                <input
                  type="file"
                  name="ProImg"
                  accept=".JPG,.PNG"
                  @change="uploadEnNewImgPC($event)"
                />
                <p class="divider"></p>
                <div class="d-flex justify-content-around">
                  <div>
                    <p class="align_c">
                      <span class="btnStyle btnGray">Select Image</span>
                    </p>
                  </div>
                  <div v-if="modelSrc !== OImgSrc">
                    <p class="align_c">
                      <span class="btnStyle btnRed" @click.prevent="resetImg"
                        >Reset Image
                      </span>
                    </p>
                  </div>
                </div>
              </label>
              <div class="uploadAlert">
                <p class="italic">File Size：Maximum 3MB</p>
                <p class="italic">File Format：JPG、PNG</p>
                <p class="italic">Pixel Size：Minimum 500 x 500 Pixel</p>
              </div>
            </div>

            <!-- 行動版圖片顯示 -->

            <div class="proLeft MbDevice">
              <label class="inputFile pointer">
                <div class="mb-3">
                  <img :src="modelSrc" class="img-fluid" />
                </div>
                <p class="my-3">&nbsp;</p>
                <span name="showName" class="nowrap"></span>
                <input
                  type="file"
                  name="ProImg"
                  accept=".JPG,.PNG"
                  @change="uploadEnNewImgMb($event)"
                />
                <p class="divider"></p>
                <div class="d-flex justify-content-around">
                  <div>
                    <p class="align_c">
                      <span class="btnStyle btnGray">Select</span>
                    </p>
                  </div>
                  <div v-if="modelSrc !== OImgSrc">
                    <p class="align_c">
                      <span class="btnStyle btnRed" @click.prevent="resetImg"
                        >Reset
                      </span>
                    </p>
                  </div>
                </div>
              </label>
              <div class="uploadAlert">
                <p class="italic">File Size：Maximum 3MB</p>
                <p class="italic">File Format：JPG、PNG</p>
                <p class="italic">Pixel Size：Minimum 500 x 500 Pixel</p>
              </div>
            </div>
            <!-- left end -->
            <!-- right -->
            <div class="proRight">
              <p class="formTitle">Display</p>

              <!-- <div class="form-check-inline">
                            <div class="formstatus">
                                <input class="form-check-input" type="radio" name="Radios" id="yes" :true-value="1"
                                    v-model="productList.Archived" value="0">
                                <label class="form-check-label" for="yes">
                                    Show</label>
                            </div>
                            <div class="ml-2">
                                <input class="form-check-input" type="radio" name="Radios" id="no" :true-value="0"
                                    v-model="productList.Archived" value="1">
                                <label class="form-check-label" for="no">
                                    Hide
                                </label>
                            </div>
                        </div> -->

              <!-- <div v-if="productList.Archived == 1">
                <span class="pointer" @click="ChangeArchived(1)"
                  ><img src="@/assets/images/off-button.png" width="35px" class="mb-1 mr-1" /> Hide</span
                >
              </div>
              <div v-else>
                <span class="pointer" @click="ChangeArchived(0)"
                  ><img src="@/assets/images/on-button.png" width="35px" class="mb-1 mr-1" /> Show</span
                >
              </div> -->

              <div v-if="productList.Archived == 1">
                <div
                  class="pointer d-flex align-items-center"
                  @click="ChangeArchived(1)"
                >
                  <div>
                    <img
                      src="@/assets/images/off-button.png"
                      width="35px"
                      class="mt-2 mr-2"
                    />
                  </div>
                  <div>Hide</div>
                </div>
              </div>
              <div v-else>
                <div
                  class="pointer d-flex align-items-center"
                  @click="ChangeArchived(0)"
                >
                  <div>
                    <img
                      src="@/assets/images/on-button.png"
                      width="35px"
                      class="mt-2 mr-2"
                    />
                  </div>
                  <div>Show</div>
                </div>
              </div>
              <p class="my-3">&nbsp;</p>
              <p class="formTitle">Product Name <span class="red">*</span></p>
              <div class="langTip">
                <input
                  type="text"
                  name="eProName"
                  class="textStyle maxText"
                  v-model="productList.eProName"
                  placeholder="English"
                  maxlength="200"
                  required
                />
                <span>EN</span>
              </div>

              <div v-if="LocalExh">
                <p class="divider"></p>
                <div class="langTip">
                  <input
                    type="text"
                    name="ProName"
                    class="textStyle maxText"
                    v-model="productList.ProName"
                    placeholder="Chinese"
                    maxlength="200"
                  />
                  <span>CN</span>
                </div>
              </div>
              <p class="my-3">&nbsp;</p>
              <div class="right">
                <p class="formTitle">Model</p>
                <input
                  type="text"
                  name="ProModel"
                  class="textStyle maxText mb-3"
                  v-model="productList.ProModel"
                  maxlength="50"
                />
              </div>
              <div class="left">
                <p class="formTitle">Category <span class="red">*</span></p>

                <div v-if="HasSubCategory">
                  <div v-if="showCategory">
                    <div class="d-flex align-items-center">
                      <div>
                        {{ showCategory }}
                      </div>

                      <div
                        class="btn btn-outline-info ml-2 py-1"
                        @click="OpenCategoryModal"
                      >
                        Edit
                      </div>
                    </div>
                  </div>
                  <div
                    v-else-if="!showCategory"
                    class="btn btn-outline-info py-2 mt-1"
                    @click="OpenCategoryModal"
                  >
                    Select Product Category
                  </div>
                </div>
                <div v-else-if="!HasSubCategory">
                  <select
                    class="form-control text-dark"
                    v-model="optionCatNo"
                    required
                  >
                    <option value="">-- Select --</option>
                    <option
                      v-for="item in ProductCategory"
                      :value="item.MainCategoryId"
                    >
                      {{ item.MainCategoryNameEn }}
                    </option>
                  </select>
                </div>
              </div>
              <p class="clear"></p>
              <p class="my-3">&nbsp;</p>

              <p class="formTitle">
                Description (English)<span class="red">*</span>
              </p>
              <textarea
                name="eProDesc"
                rows="6"
                class="maxText textStyle"
                v-model="productList.eProDesc"
                placeholder="English"
                required
              ></textarea>

              <p class="my-3">&nbsp;</p>
              <div v-if="LocalExh">
                <p class="formTitle">Description (Chinese)</p>
                <textarea
                  name="ProDesc"
                  rows="6"
                  class="maxText textStyle"
                  v-model="productList.ProDesc"
                  placeholder="Chinese"
                ></textarea>
              </div>
            </div>
            <!-- right end -->
            <p class="clear"></p>
            <p class="my-3">&nbsp;</p>
            <div class="text-center PcDevice">
              <button class="btn btn-lg btn-primary mr-3" type="submit">
                Confirm
              </button>
              <button
                class="btn btn-lg btn-secondary"
                @click.prevent="backProPage"
              >
                Back
              </button>
            </div>
            <div class="text-center MbDevice">
              <button class="btn btn-primary mr-3" type="submit">
                Confirm
              </button>
              <button class="btn btn-secondary" @click.prevent="backProPage">
                Back
              </button>
            </div>
          </form>

          <!-- 桌機板裁切工具 Modal  -->
          <div id="cropImagePop" class="modal fade" tabindex="-1" role="dialog">
            <div class="modal-dialog modal-xl" role="document">
              <div class="modal-content">
                <div class="modal-header d-flex justify-content-between">
                  <div class="modal-title" style="font-size: 25px">
                    <div class="d-flex align-self-center">
                      <div class="mr-3">
                        <img src="@/assets/images/cropImg.png" width="30px" />
                      </div>
                      <div style="font-size: 25px">Edit Image</div>
                    </div>
                  </div>

                  <div
                    type="button"
                    class="close"
                    data-dismiss="modal"
                    aria-label="Close"
                  >
                    <span aria-hidden="true">&times;</span>
                  </div>
                </div>
                <div class="modal-body">
                  <div class="row">
                    <div class="col-sm-8">
                      <div class="CropBoxStyle">
                        <vue-cropper
                          ref="cropper"
                          :img="option.img"
                          :output-size="option.size"
                          :output-type="option.outputType"
                          :info="true"
                          :full="option.full"
                          :fixed="fixed"
                          :can-move="option.canMove"
                          :can-move-box="option.canMoveBox"
                          :fixed-box="option.fixedBox"
                          :original="option.original"
                          :auto-crop="option.autoCrop"
                          :auto-crop-width="option.autoCropWidth"
                          :auto-crop-height="option.autoCropHeight"
                          :center-box="option.centerBox"
                          :high="option.high"
                          :max-img-size="option.max"
                          :fixed-number="fixedNumber"
                          :enlarge="option.enlarge"
                          :infoTrue="option.infoTrue"
                          :mode="option.mode"
                          @real-time="realTime"
                        >
                        </vue-cropper>
                      </div>

                      <div class="d-flex justify-content-between mt-3 mx-3">
                        <div>
                          <button @click="rotateLeft" class="btn btn-info">
                            Rotate Left
                          </button>
                          <button
                            @click="rotateRight"
                            class="btn btn-info ml-2"
                          >
                            Rotate Right
                          </button>
                          <button
                            @click="changeScale(1)"
                            class="btn btn-info ml-2"
                          >
                            +
                          </button>
                          <button
                            @click="changeScale(-1)"
                            class="btn btn-info ml-2"
                          >
                            -
                          </button>
                        </div>
                        <div>
                          <button
                            @click="refreshCrop"
                            class="btn btn-outline-info"
                          >
                            Reset
                          </button>
                        </div>
                      </div>
                    </div>
                    <div class="col-sm-4">
                      <div :style="previewStyle1" class="ImgPreCrop">
                        <div :style="previews.div">
                          <img :src="previews.url" :style="previews.img" />
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <hr />
                <div class="modal-footer">
                  <div>
                    <button
                      type="button"
                      id="cropImageBtn"
                      class="btn btn-lg btn-primary mr-2"
                      @click="OutputEnPC()"
                    >
                      Crop
                    </button>
                    <button
                      type="button"
                      class="btn btn-secondary btn-lg"
                      data-dismiss="modal"
                    >
                      Close
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <!-- 行動版裁切工具 Modal  -->
          <div
            class="modal fade"
            id="cropperMb"
            tabindex="-1"
            role="dialog"
            aria-labelledby="exampleModalCenterTitle"
            aria-hidden="true"
            data-backdrop="static"
            data-keyboard="false"
          >
            <div
              class="modal-dialog modal-sm modal-dialog-centered"
              role="document"
            >
              <div class="modal-content">
                <div class="modal-body">
                  <p>
                    &middot; Automatically resize your image into square image.
                  </p>
                  <p>
                    &middot; If you need to crop or edit your image, please use
                    the computer to upload your image.
                  </p>
                </div>

                <div class="modal-footer">
                  <button
                    type="button"
                    id="cropperMb"
                    class="btn btn-sm btn-primary"
                    @click="OutputEnMb()"
                  >
                    OK
                  </button>
                </div>
              </div>
            </div>
          </div>

          <!-- 選擇兩層產品類型 Modal  -->

          <!-- 產品分類彈跳視窗 -->
          <div
            class="modal fade"
            id="SearchModal"
            tabindex="-1"
            role="dialog"
            aria-labelledby="exampleModalLongTitle"
            aria-hidden="true"
            style="z-index: 5000"
          >
            <div class="modal-dialog modal-lg" role="document">
              <div class="modal-content">
                <div
                  class="modal-header modal-title-bg"
                  style="background-color: #f5f7fa"
                >
                  <h4
                    class="modal-title"
                    style="font-size: 25px"
                    id="exampleModalLongTitle"
                  >
                    Select Product Category
                  </h4>

                  <div
                    type="button"
                    class="modal-close pointer"
                    data-dismiss="modal"
                    aria-label="Close"
                    style="font-size: 28px; font-weight: bold"
                  >
                    <span aria-hidden="true">&times;</span>
                  </div>
                </div>
                <div class="modal-body">
                  <div class="mb-3 mt-2">
                    <div class="mb-4">
                      <el-collapse v-model="Tab_Category">
                        <el-collapse-item
                          v-for="(item, parentIndex) in ProductCategory"
                          :key="parentIndex"
                          :title="`${parentIndex + 1}. ${
                            item.MainCategoryNameEn
                          }`"
                          :name="parentIndex"
                        >
                          <div class="row">
                            <div
                              class="col-lg-6 my-1"
                              v-for="(Category, childIndex) in item.SubCategory"
                              :key="childIndex"
                            >
                              <div class="custom-control custom-radio">
                                <input
                                  type="radio"
                                  name="checkAll"
                                  class="custom-control-input"
                                  :value="Category.CategoryId"
                                  :id="Category.CategoryId"
                                  v-model="SelectedCatId"
                                />
                                <label
                                  class="custom-control-label CategoryPointer"
                                  :for="Category.CategoryId"
                                  >{{ Category.CategoryNameEn }}</label
                                >
                              </div>
                            </div>
                          </div>
                        </el-collapse-item>
                      </el-collapse>
                    </div>
                  </div>
                </div>

                <div class="modal-footer" style="display: inline">
                  <div class="d-flex justify-content-end align-items-center">
                    <button
                      type="button"
                      id="cropImageBtn"
                      class="btn btn-lg btn-primary mr-2"
                      @click="confirmCategory"
                    >
                      Confirm
                    </button>
                    <button
                      type="button"
                      class="btn btn-lg btn-secondary"
                      data-dismiss="modal"
                    >
                      Close
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div v-if="showImg" class="CropBoxStyle">
            <vue-cropper
              ref="cropper"
              :img="option.img"
              :output-size="option.size"
              :output-type="option.outputType"
              :info="true"
              :full="option.full"
              :fixed="fixed"
              :can-move="option.canMove"
              :can-move-box="option.canMoveBox"
              :fixed-box="option.fixedBox"
              :original="option.original"
              :auto-crop="option.autoCrop"
              :auto-crop-width="option.autoCropWidth"
              :auto-crop-height="option.autoCropHeight"
              :center-box="option.centerBox"
              :high="option.high"
              :max-img-size="option.max"
              :fixed-number="fixedNumber"
              :enlarge="option.enlarge"
              :infoTrue="option.infoTrue"
              :mode="option.mode"
            >
            </vue-cropper>
          </div>
        </div>
      </div>
    </article>
  </div>
</template>

<script>
import $ from "jquery";
import axios from "axios";

export default {
  metaInfo() {
    return {
      title: `Products - Chan Chao Exhibitor's Online Service System`,
    };
  },

  data() {
    return {
      HasSubCategory: false,
      showCategory: "",
      SelectedCatId: "",
      UserId: "",
      showImg: false,
      CSRF_Token: "",
      RegNo: "",
      ProductWarning: "",
      ProductID: "",
      productList: [],
      ProductCategory: [],
      ProTwoCatList: [],
      hasProTwoCat: false,
      optionCatNo: "",
      ProductCatNo: "",
      SelectCat: [],

      previews: {},
      previewStyle1: {},
      modelSrc: "",
      OImgSrc: "", // 原始圖片

      option: {
        img: "", // 裁剪图片的地址
        max: 9999, //限制图片最大宽度和高度
        enlarge: 1,
        mode: "contain",

        centerBox: false, // 截图框是否被限制在图片里面
        canMove: true, //上传图片是否可以移动
        infoTrue: true,

        fixedBox: true, // 固定截图框大小 不允许改变
        canMoveBox: false, // 截图框能否拖动
        autoCrop: true, // 是否默认生成截图框
        // 只有自动截图开启 宽度高度才生效
        autoCropWidth: 500, // 默认生成截图框宽度
        autoCropHeight: 500,

        full: false, //是否输出原图比例的截图，X匯出等比例(長型就匯長型)
        high: false, //是否按照设备的dpr 输出等比例图片，X匯出等比例(長型就匯長型)
        original: false, // 上传图片按照原始比例渲染

        size: 0.7, //裁剪生成图片的质量
        outputType: "png", // 裁剪生成图片的格式
      },

      fixed: true, // 是否开启截图框宽高固定比例
      fixedNumber: [1, 1], // 截图框的宽高比例
      lang: "en",

      currentPage: 0,
      optionAr: false,
      initialLogo: "",

      Tab_Category: [0],
      SelectCatName: "",
      MainCatName: "",

      optionCatNo: "", //產品類別號碼

      LocalExh: true,
      selectedCategoryName: "",
    };
  },

  watch: {
    SelectedCatId(newVal) {
      if (!newVal) return;

      const found = this.ProductCategory.flatMap(
        (main) => main.SubCategory
      ).find((sub) => sub.CategoryId === String(newVal));

      if (found) {
        this.selectedCategoryName = found.CategoryNameEn;
      } else {
        this.selectedCategoryName = "";
      }
    },
  },

  methods: {
    confirmCategory() {
      const vm = this;

      if (vm.SelectedCatId) {
        vm.showCategory = vm.selectedCategoryName;
        $("#SearchModal").modal("hide");
        vm.optionCatNo = vm.SelectedCatId;
      } else {
        $("#SearchModal").modal("hide");
      }
    },

    OpenCategoryModal() {
      $("#SearchModal").modal("show");
    },
    resetImg() {
      const vm = this;
      vm.modelSrc = vm.OImgSrc;
    },

    ChangeArchived(status) {
      const vm = this;

      if (status == 1) {
        vm.$set(vm.productList, "Archived", 0);
      } else {
        vm.$set(vm.productList, "Archived", 1);
      }
    },

    updateProduct() {
      const vm = this;
      const url = `/apiExhibitors/Product/${vm.RegNo}/${vm.ProductID}`;

      if (vm.modelSrc == vm.initialLogo) {
        // console.log(33)
        var info2 = {
          CSRF: vm.CSRF_Token,
          ProImg: "",
          category: vm.optionCatNo,
          ProName: vm.productList.ProName,
          eProName: vm.productList.eProName,
          ProModel: vm.productList.ProModel,
          ProDesc: vm.productList.ProDesc,
          eProDesc: vm.productList.eProDesc,
          Archived: vm.productList.Archived,
        };
      } else {
        // console.log(66)

        var info2 = {
          CSRF: vm.CSRF_Token,
          ProImg: vm.modelSrc,
          category: vm.optionCatNo,
          ProName: vm.productList.ProName,
          eProName: vm.productList.eProName,
          ProModel: vm.productList.ProModel,
          ProDesc: vm.productList.ProDesc,
          eProDesc: vm.productList.eProDesc,
          Archived: vm.productList.Archived,
        };
      }

      if (
        !vm.optionCatNo ||
        !vm.productList.eProName ||
        !vm.productList.eProDesc
      ) {
        alert("There are incomplete fields, please check again.");
      } else {
        axios.post(url, info2).then(function (response) {
          if (response.data.Code == 200) {
            // alert('Successfully changed your product information.')
            document.location.href = `https://www.chanchao.com.tw/ExhibitorServiceTW/en/product?no=${vm.RegNo}`;
          } else if (response.data.Code == 251) {
            alert("System is busy, please try again later.");
            document.location.href = `https://www.chanchao.com.tw/ExhibitorServiceTW/en/product?no=${vm.RegNo}`;
          } else if (response.data.Code == 252) {
            document.location.href = `https://www.chanchao.com.tw/`;
          } else if (response.data.Code == 253) {
            alert("Image upload failed. ");
          }
        });
      }
    },

    uploadNewImgPC(e) {
      const vm = this;

      let file = e.target.files[0];
      if (!/\.(png|jpg|JPG|PNG)$/.test(e.target.value)) {
        alert("上傳檔案類型必須是 JPG,PNG！");
        return false;
      }

      let reader = new FileReader();

      reader.onload = (e) => {
        const isLt5M = e.total / 1024 / 1024 < 3;

        // console.log(e)
        if (isLt5M) {
          $("#cropImagePop").modal("show");

          $("#cropImagePop").on("shown.bs.modal", function () {
            vm.option.img = window.URL.createObjectURL(
              new Blob([e.target.result])
            );
          });
        } else {
          alert("上傳圖片大小請勿超過 3MB！");
        }
      };

      reader.readAsArrayBuffer(file);
      e.target.value = "";
    },

    uploadEnNewImgPC(e) {
      const vm = this;

      let file = e.target.files[0];
      if (!/\.(png|jpg|JPG|PNG)$/.test(e.target.value)) {
        alert("Upload file must be in JPG or PNG！");
        return false;
      }

      let reader = new FileReader();

      reader.onload = (e) => {
        const isLt5M = e.total / 1024 / 1024 < 3;

        // console.log(e)
        if (isLt5M) {
          $("#cropImagePop").modal("show");

          $("#cropImagePop").on("shown.bs.modal", function () {
            vm.option.img = window.URL.createObjectURL(
              new Blob([e.target.result])
            );
          });
        } else {
          alert("Maximum file size : 3MB");
        }
      };

      reader.readAsArrayBuffer(file);
      e.target.value = "";
    },

    uploadNewImgMb(e) {
      const vm = this;

      //上传图片
      // this.option.img
      var file = e.target.files[0];
      if (!/\.(png|jpg|JPG|PNG)$/.test(e.target.value)) {
        alert("上傳檔案類型必須是 JPG,PNG！");
        return false;
      }
      var reader = new FileReader();
      reader.readAsArrayBuffer(file);

      reader.onload = (e) => {
        const isLt5M = e.total / 1024 / 1024 < 3;

        if (isLt5M) {
          this.option.img = window.URL.createObjectURL(
            new Blob([e.target.result])
          );
          vm.showImg = true;
          $("#cropperMb").modal("show");
        } else {
          alert("上傳圖片大小請勿超過 3MB！");
        }
      };
      e.target.value = "";
    },

    uploadEnNewImgMb(e) {
      const vm = this;

      //上传图片
      // this.option.img
      var file = e.target.files[0];
      if (!/\.(png|jpg|JPG|PNG)$/.test(e.target.value)) {
        alert("Upload file must be in JPG or PNG！ ");
        return false;
      }
      var reader = new FileReader();
      reader.readAsArrayBuffer(file);

      reader.onload = (e) => {
        const isLt5M = e.total / 1024 / 1024 < 3;

        if (isLt5M) {
          this.option.img = window.URL.createObjectURL(
            new Blob([e.target.result])
          );
          vm.showImg = true;
          $("#cropperMb").modal("show");
        } else {
          alert("Maximum file size : 3MB");
        }
      };
      e.target.value = "";
    },

    OutputPC() {
      const vm = this;

      this.$refs.cropper.getCropData((data) => {
        // console.log(data)
        this.modelSrc = data;
        $("#cropImagePop").modal("hide");

        $("#cropImagePop").on("hidden.bs.modal", function (e) {
          vm.option.img = "/";
        });

        window.setTimeout(
          () =>
            alert(
              "恭喜您成功更改圖片，提醒您需按下「確認送出」鍵，以完成修改產品之程序。"
            ),
          1000
        );
      });
    },

    OutputEnPC() {
      const vm = this;

      this.$refs.cropper.getCropData((data) => {
        // console.log(data)
        this.modelSrc = data;
        $("#cropImagePop").modal("hide");

        $("#cropImagePop").on("hidden.bs.modal", function (e) {
          vm.option.img = "/";
        });
        window.setTimeout(
          () =>
            alert(
              'After you change the product picture, please click "Confirm" to ensure the revision has been completed.'
            ),
          1000
        );
      });
    },

    OutputMb() {
      // 输出
      const vm = this;

      this.$refs.cropper.getCropData((data) => {
        // console.log(data)
        this.modelSrc = data;
      });

      $("#cropperMb").modal("hide");
      vm.showImg = false;

      window.setTimeout(
        () =>
          alert(
            "恭喜您成功更改圖片，提醒您需按下「確認送出」鍵，以完成修改產品之程序。"
          ),
        1000
      );
    },

    OutputEnMb() {
      // 输出
      const vm = this;

      this.$refs.cropper.getCropData((data) => {
        // console.log(data)
        this.modelSrc = data;
      });

      $("#cropperMb").modal("hide");
      vm.showImg = false;

      window.setTimeout(
        () =>
          alert(
            'After you change the product picture, please click "Confirm" to ensure the revision has been completed.'
          ),
        1000
      );
    },

    realTime(data) {
      var previews = data;
      var h = 0.5;
      var w = 0.2;

      this.previewStyle1 = {
        width: previews.w + "px",
        height: previews.h + "px",
        overflow: "hidden",
        margin: "0",
        zoom: h,
      };

      this.previews = data;
    },

    rotateLeft() {
      this.$refs.cropper.rotateLeft();
    },
    rotateRight() {
      this.$refs.cropper.rotateRight();
    },

    changeScale(num) {
      num = num || 1;
      this.$refs.cropper.changeScale(num);
    },

    refreshCrop() {
      this.$refs.cropper.refresh();
    },

    backProPage() {
      const vm = this;
      if (vm.lang == "tw") {
        document.location.href = `https://www.chanchao.com.tw/ExhibitorServiceTW/product?no=${vm.RegNo}`;
      } else {
        document.location.href = `https://www.chanchao.com.tw/ExhibitorServiceTW/en/product?no=${vm.RegNo}`;
      }
    },
  },

  created() {
    const vm = this;

    //CSRF_Token
    axios
      .get("https://www.chanchao.com.tw/apiExhibitors/CSRF_Token")
      .then((response) => {
        vm.CSRF_Token = response.data;
      });

    axios
      .get(`https://www.chanchao.com.tw/apiExhibitors/UserID`)
      .then((response) => {
        vm.UserId = response.data;
      });

    //url取出展碼
    let currentUrl = location.href;
    vm.RegNo = currentUrl.split("no=")[1].split("&")[0];
    vm.ProductID = currentUrl.split("id=")[1].split("&")[0];

    if (currentUrl.split("Page=")[1]) {
      vm.currentPage = currentUrl.split("Page=")[1];
    }

    let url = `/apiExhibitors/Product/${vm.RegNo}/${vm.ProductID}`;
    axios
      .get(url)
      .then(function (response) {
        if (response.data.Data) {
          vm.productList = response.data.Data;
          vm.optionCatNo = vm.productList.CatNo;
          vm.SelectedCatId = vm.optionCatNo;

          if (vm.productList.Archived == 0) {
            vm.optionArchived = true;
          } else {
            vm.optionArchived = false;
          }

          vm.ProductCatNo = vm.productList.CatNo;
          vm.modelSrc = `//www.chanchao.com.tw/exhibitorServicefiles/products/${response.data.Data.ProImg}`;
          vm.OImgSrc = `//www.chanchao.com.tw/exhibitorServicefiles/products/${response.data.Data.ProImg}`;
          vm.initialLogo = `//www.chanchao.com.tw/exhibitorServicefiles/products/${response.data.Data.ProImg}`;

          vm.optionCatNo = response.data.Data.CatNo;

          //取得產品類別列表
          let url2 = `/apiExhibitors/ProductCategory/${vm.RegNo}`;
          axios.get(url2).then(function (response) {
            // console.log(response.data.Data)
            vm.ProductCategory = response.data.Data.ProductMainCategory;
            vm.HasSubCategory = response.data.Data.HasSubCategory;

            if (vm.HasSubCategory) {
              let allSub = vm.ProductCategory.flatMap(
                (main) => main.SubCategory
              );
              let found = allSub.find(
                (sub) => sub.CategoryId == vm.optionCatNo
              );
              if (found) {
                vm.showCategory = found.CategoryNameEn;
              }
            } else {
              let ShowName2 = vm.ProductCategory.filter(function (item) {
                return item.CatNo == vm.optionCatNo;
              });
              vm.showCategory = ShowName2[0].CatName;
            }
            //取得產品欄位警語
            axios
              .get(`/apiExhibitors/ProductWarning/${vm.RegNo}?lang=${vm.lang}`)
              .then(function (response) {
                vm.ProductWarning = response.data.Data.ProductWarning;
              });
          });

          //取得產品類別列表
          // let url3 = `/apiExhibitors/ProductCategoryTwoLayer/${vm.RegNo}`;
          // axios.get(url3).then(function (response) {
          //   if (response.data.Code == 200) {
          //     vm.ProTwoCatList = response.data.Data;

          //     let GetCatName2 = vm.ProTwoCatList.filter(function (item) {
          //       return item.subCategory.find(function (item2) {
          //         return item2.CatNo == vm.optionCatNo;
          //       });
          //     });
          //     vm.MainCatName = GetCatName2[0].emainCatName;

          //     vm.hasProTwoCat = true;
          //   } else {
          //     vm.hasProTwoCat = false;
          //   }
          // });
        } else {
          alert("Unavailable URL 網址連結有誤，將自動為您重新導向！");
          document.location.href = `https://www.chanchao.com.tw/ExhibitorServiceTW/product?no=${vm.RegNo}`;
        }
      })
      .catch((err) => {
        alert("Unavailable URL 網址連結有誤，將自動為您重新導向！");
        document.location.href = `https://www.chanchao.com.tw/ExhibitorServiceTW/product?no=${vm.RegNo}`;
      });

    //取得產品欄位警語
    axios
      .get(`/apiExhibitors/ProductWarning/${vm.RegNo}?lang=${vm.lang}`)
      .then(function (response) {
        vm.ProductWarning = response.data.Data.ProductWarning;
      });

    axios
      .get(
        `https://www.chanchao.com.tw/apiExhibitors/Exhibition/${vm.RegNo}?lang=tw`
      )
      .then((response) => {
        if (response.data.Code == 200) {
          let ExpoLocation = response.data.Data.ExpoLocation;

          if (ExpoLocation === "T" || ExpoLocation === null) {
            vm.LocalExh = true;
          } else {
            vm.LocalExh = false;
          }
        } else if (response.data.Code == 404) {
          // console.log('查無資料')
        } else {
          alert("系統忙線中，請稍後再試");
        }
      });
  },
};
</script>

<style lang="scss">
.form-control {
  height: calc(2.2em + 0.75rem + 2px);
}

// @media screen and (min-width: 331px) and (max-width: 576px) {
//   .modal-content {
//     width: 65%;
//   }
// }

// @media screen and (max-width: 330px) {
//   .modal-content {
//     width: 60%;
//   }
// }

.modal-xl {
  max-width: 940px;
}

.modal-body {
  height: 75vh;
  overflow-y: auto;
}

.custom-control-label {
  font-size: 15px;
}

@media screen and (max-width: 800px) {
  .el-collapse-item__header {
    font-size: 14px;
    font-weight: 550;

    height: 70px;
    line-height: 18px;
  }
}

@media screen and (min-width: 801px) {
  .el-collapse-item__header {
    font-size: 17px;
    font-weight: 550;

    height: 60px;
    line-height: 25px;
  }
}
</style>
